import { FinanceDirectoryStatusFilter } from "@/features/finance/model/finance-types";
import type { TableQueryConfig } from "@/shared/lib/data-table/table-query";

/**
 * Declarative table config for Finance → Accounts. The backend supports search + status,
 * page/limit pagination and sorting on createdAt | updatedAt | name
 * (apps/api/src/modules/finance/schemas/accounts.schemas.ts).
 */
export const financeAccountsTableQueryConfig: TableQueryConfig = {
  id: "finance-accounts",
  titleKey: "toolbar.filters",
  buttonLabelKey: "toolbar.filters",
  cancelLabelKey: "toolbar.cancel",
  resetLabelKey: "toolbar.reset",
  applyLabelKey: "toolbar.applyFilters",
  clearLabelKey: "toolbar.clearFilters",
  search: {
    placeholderKey: "searchPlaceholder",
    testId: "settings-accounts-search-input",
    debounceMs: 300,
    className: "w-full sm:max-w-md",
  },
  defaultSortBy: "name",
  defaultSortOrder: "asc",
  defaultLimit: 20,
  defaultPage: 1,
  filters: [
    {
      id: "status",
      type: "select",
      key: "status",
      labelKey: "statusLabel",
      options: {
        type: "static",
        items: [
          { value: "", labelKey: "allStatuses" },
          { value: FinanceDirectoryStatusFilter.Active, labelKey: "status.active" },
          { value: FinanceDirectoryStatusFilter.Archived, labelKey: "status.archived" },
        ],
      },
    },
  ],
};
